const SENSITIVE_KEYS = /token|secret|password|passphrase|priv|private|invite|authorization|subscription/i;
function redact(value) {
    if (Array.isArray(value))
        return value.map(redact);
    if (!value || typeof value !== 'object')
        return value;
    const out = {};
    for (const [key, val] of Object.entries(value)) {
        out[key] = SENSITIVE_KEYS.test(key) ? '[redacted]' : redact(val);
    }
    return out;
}
export function createLogger(enabled = false) {
    return {
        debug(message, meta) {
            if (enabled)
                console.debug(message, meta === undefined ? '' : redact(meta));
        },
        warn(message, meta) {
            if (enabled)
                console.warn(message, meta === undefined ? '' : redact(meta));
        },
        error(message, meta) {
            console.error(message, meta === undefined ? '' : redact(meta));
        }
    };
}
//# sourceMappingURL=logger.js.map